<template>
<div>
<v-btn absolute dark fab top right color="primary" style="top:10px;" @click="subDistrictDialog = true">
    <v-icon color="black">add</v-icon>
</v-btn>
<subDistrictForm :dialog="subDistrictDialog" @setDialog="subDistrictDialog = $event"
:editedIndex="editedIndex" 
@setEditIndex="editedIndex = $event"/>
<v-data-table :headers="headers" :items="users" :pagination.sync="pagination">
    <template slot="items" slot-scope="props">
    <td class="text-xs-center">{{ props.item.num }}</td>
    <td class="text-xs-center">{{ props.item.zone_name }}</td>
    <td class="justify-center layout px-0">
        <v-tooltip top>
            <v-btn icon @click="editSubZone()" slot="activator">
            <v-icon small>
            edit
            </v-icon>
            </v-btn>
            <span>Edit</span>
        </v-tooltip>
            <v-tooltip top>
            <v-btn icon slot="activator">
            <v-icon small>
            delete
            </v-icon>
            </v-btn>
            <span>Delete</span>
        </v-tooltip>
    </td>
</template>

<template slot="no-data">
    <v-btn color="primary" @click="initialize">Reset</v-btn>
</template>

</v-data-table>

 <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
</div> -->
  </div>
</template>

<script>
import subDistrictForm from './SubDistrictForm'
    export default {
        data: () => ({
            subDistrictDialog : false,
            dialog: false,
            editedIndex: -1,
            pagination: {
                rowsPerPage:10
            },
            headers: [
                {
                    text: '#',
                    align: 'center',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: 'Sub district name',
                    align: 'center',
                    value: 'role',
                    sortable: false,
                },
                {
                    text: 'Action',
                    align: 'center',
                    value: 'name',
                    sortable: false
                }
            ]
           
        }),
        components:{
            subDistrictForm
        },
        computed: {
            pages () {
                if (this.pagination.rowsPerPage == null ||
                this.pagination.totalItems == null
                ) return 0

                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
            }
        },
    
        watch: {
            dialog(val) {
                val || this.close()
            }
        },
    
        created() {
            this.initialize()
        },
    
        methods: {
            initialize() {
                this.users = [{
                        num: '1',
                        zone_name: 'ราไวย์ เขต 1',
                        action: ''
                    }
                ]
            },
            editSubZone() {
            this.subDistrictDialog = true;
            this.editedIndex = 1;
            }
        }
    }
</script>

